import { Grid, LoadingOverlay, Title } from "@mantine/core";
import React, { useEffect } from "react";
import Select from "../../../components/Select/Select";
import TextInput from "../../../components/Input/TextInput";
import { useQuery } from "react-query";
import { showNotification } from "@mantine/notifications";
import { GetUsersData } from "../../../components/GeneralComponents/GetUsersData";
import { CustomSelect } from "../../../components/GeneralComponents/CustomSelect";
import { LoaderWrapper } from "../../../components/GeneralComponents/LoaderWrapper";

const AddBuyerModal = ({ form, coBuyer = false, customers, isLoading, isFetching }) => {
  useEffect(() => {
    if (customers && (coBuyer ? form.values.coBuyer : form.values.customer)) {
      const selectedCustomer = customers.data?.find((customer) => customer.id === (coBuyer ? form.values.coBuyer : form.values.customer));
      if (!selectedCustomer) return;
      form.setFieldValue(coBuyer ? "coBuyer" : "customer", selectedCustomer?.id);
      form.setFieldValue(coBuyer ? "coBuyerFirstName" : "firstName", selectedCustomer?.firstName);
      form.setFieldValue(coBuyer ? "coBuyerMiddleName" : "middleName", selectedCustomer?.middleName);
      form.setFieldValue(coBuyer ? "coBuyerLastName" : "lastName", selectedCustomer?.lastName);
      form.setFieldValue(coBuyer ? "coBuyerFullName" : "fullName", selectedCustomer?.fullName);
      form.setFieldValue(coBuyer ? "coBuyerEmail" : "email", selectedCustomer?.email);
      form.setFieldValue(coBuyer ? "coBuyerZipCode" : "zipCode", selectedCustomer?.zipCode);
      form.setFieldValue(coBuyer ? "coBuyerCellPhone" : "cellPhone", selectedCustomer?.phoneNumber);
    }
  }, [form.values.customer, form.values.coBuyer, customers]);

  return (
    <LoaderWrapper loading={isLoading || isFetching}>
      <Grid>
        <Grid.Col md={12}>
          <Title align="center" order={2}>
            Select A {coBuyer ? "Co-Buyer" : "Buyer"}
          </Title>
        </Grid.Col>
        <Grid.Col md={12}>
          <Select
            label={coBuyer ? "Co-Buyer" : "Buyer"}
            searchable={true}
            placeholder={`Select ${coBuyer ? "Co-Buyer" : "Buyer"}`}
            data={customers?.forSelect || []}
            itemComponent={CustomSelect}
            form={form}
            withAsterisk={true}
            validateName={coBuyer ? "coBuyer" : "customer"}
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <TextInput
            label={"First Name"}
            placeholder={coBuyer ? "Co-Buyer's First Name" : "Buyer's First Name"}
            form={form}
            withAsterisk={true}
            validateName={coBuyer ? "coBuyerFirstName" : "firstName"}
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <TextInput
            label={"Middle Name"}
            placeholder={coBuyer ? "Co-Buyer's Middle Name" : "Buyer's Middle Name"}
            form={form}
            validateName={coBuyer ? "coBuyerMiddleName" : "middleName"}
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <TextInput
            label={"Last Name"}
            placeholder={coBuyer ? "Co-Buyer's Last Name" : "Buyer's Last Name"}
            form={form}
            withAsterisk={true}
            validateName={coBuyer ? "coBuyerLastName" : "lastName"}
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <TextInput
            label={"Cell Number"}
            placeholder={coBuyer ? "Co-Buyer's Cell Number" : "Buyer's Cell Number"}
            form={form}
            withAsterisk={true}
            validateName={coBuyer ? "coBuyerCellPhone" : "cellPhone"}
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <TextInput
            label={"Email"}
            placeholder={coBuyer ? "Co-Buyer's Email" : "Buyer's Email"}
            form={form}
            withAsterisk={true}
            validateName={coBuyer ? "coBuyerEmail" : "email"}
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <TextInput
            label={"ZIP Code"}
            placeholder={coBuyer ? "Co-Buyer's ZIP Code" : "Buyer's ZIP Code"}
            form={form}
            withAsterisk={true}
            validateName={coBuyer ? "coBuyerZipCode" : "zipCode"}
          />
        </Grid.Col>
      </Grid>
    </LoaderWrapper>
  );
};

export default AddBuyerModal;
